export default {
  summary_one: '{{count}} Artikel wurde entfernt · nicht verfügbar zu deiner Abholzeit',
  summary_other: '{{count}} Artikel wurden entfernt · nicht verfügbar zu deiner Abholzeit',
  reason: 'Verfügbar {{schedule}} — deine Abholung ist um {{time}}.',
  change_pickup_time: 'Abholzeit ändern',
  dismiss: 'Schließen',
};
